import './component.scss'
import './component_controller.js'
import { Turbo } from "@hotwired/turbo-rails"

Turbo.session.drive = false
